<template>
    <div class="simulation-wrap" v-if="colorSetting">
        <div class="simulation-btn">
            <div :class="['item','simulation',simulationPanel?'selected':'']" data-name="simulation" @click="simulationPanel=true">仿真</div>
            <div :class="['item','realtime',!simulationPanel?'selected':'']" data-name="realtime" @click="patternSwitch">实时</div>
        </div>
        <div class="simulation-content content" v-show="simulationPanel">
            <div class="begin item" data-name="begin" @click="calculateSimulation">开始计算</div>
            <div :class="['edit','item',stationConfig.pattern.name=='simulation'?'selected':'']" data-name="edit" @click="simulationStationShow">编辑</div>
        </div>
        <div class="realtime-wrap"></div>
    </div>

</template>
<script>
import {getSimulationValue} from "@api/map2d"
import Overlay from 'ol/Overlay';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';

export default {
    name:"simulation",
    props:["mainmap","stationConfig","colorSetting","pipelineConfig"],
    data(){
        return {
            simulationPanel:false, // 仿真面板
            patternName:null, // 当前所处的模式
            pipelineFeatureArray:null, // 管道图层数据
        }
    },
    watch:{
        colorSetting(){
            // 判断当前是否处于仿真模式
            if(this.stationConfig.pattern.name=="simulation"){
                // 计算模拟值
                this.calculateSimulation();
            }
        }
    },
    mounted(){
        // console.log(this.stationConfig);
    },
    methods:{
        // 模式的切换
        patternSwitch(){
            // 切换模式
            this.simulationPanel=false;
            this.$set(this.stationConfig.pattern,"name","realtime");
        },
        // 模拟状态下的站点输入
        simulationStationShow:function(){
            // 修改当前的模式
            this.$set(this.stationConfig.pattern,"name","simulation");

            //关闭其他的显示的属性框
            let overlays=this.mainmap.getOverlays();
            overlays.forEach(function(item){
                item.setPosition(undefined);
            });
            // 关闭实时时间显示
            this.$el.querySelector(".simulation-wrap .realtime-wrap").style.display="none";

            // 设置地图缩放级别
            this.mainmap.getView().setZoom(17);
            // 属性框显示的最小级别
            let propertiesZoom=15;
            // 获取地图级别，地图级别过小，不显示
            let zoom=this.mainmap.getView().getZoom();
            // 获取当前的站点配置
            // let stationConfig=this.stationConfig;
            //获取缩放比率
            let ratio=this.detectZoom();


            // 获取地图上的全部站点Feature
            let stationLayer=this.mainmap.getLayerByName("station_layer");
            let stationSource=stationLayer.getSource();

            // 获取默认的站点配置
            let pattern=this.stationConfig.pattern;
            let patternFields=pattern.fileds;
            let stationDefault=pattern.stationDefault;

            // 遍历全部参与运算的站点，并显示其默认值
            for(let stationId in stationDefault){
                // 获取对应地图上的站点Feature
                let feature=stationSource.getFeatureById(stationId);
                let featureProperties=feature.getProperties();//属性数据

                //属性框显示
                let overlay=this.mainmap.getOverlayById("simulation_"+featureProperties.id);
                let overlayDom=null;
                if(!overlay){
                    // 插入body中
                    overlayDom=document.createElement("div");
                    overlayDom.id="simulation_"+featureProperties.id;
                    overlayDom.className="ztOverlay simulation simulation_"+featureProperties.id+" "+featureProperties.type;
                    overlayDom.dataset.number=featureProperties.id;

                    let innerHTML="<div class='zt-title'>" +
                            "<span>"+featureProperties.id+(featureProperties.name?"&lt;"+featureProperties.name+"&gt;":"")+"</span>"+
                        "</div>"+
                        "<ul class='ztOverlay_content'></ul>";
                    overlayDom.innerHTML=innerHTML;

                    // 加入DOM树
                    // document.body.appendChild(overlayDom);

                    // 创建overlayer
                    overlay = new Overlay({
                        id:"simulation_"+featureProperties.id,
                        element: overlayDom,
                        positioning:featureProperties.anchor,
                        stopEvent:true,
                        position:feature.getGeometry().getCoordinates(),
                    });
                    overlay.set("group","simulation");
                    this.mainmap.addOverlay(overlay);
                }else {
                    overlayDom=overlay.getElement();
                }

                // 生成内容框
                let ztItemhtml="";
                let stationPropreties=stationDefault[stationId];
                for(let filed in stationPropreties){
                    if(patternFields[filed]){
                        let simulationName=patternFields[filed].name;
                        let unit=patternFields[filed].unit;
                        let defaultV=stationPropreties[filed];
                        ztItemhtml+="<li class='item simulation-item'>"+(simulationName)+" : <input type='text' data-name='"+filed+"' value='"+defaultV+"'> "+(unit)+"</li>";
                    }
                }
                //添加字段到显示面板
                overlayDom.querySelector(".ztOverlay_content").innerHTML=ztItemhtml;
                //设置面板的宽度
                // overlayDom.style.width="168px";
                
                //根据缩放比例进行全局缩放
                overlayDom.style.transform="scale("+ratio+")";                

                //设置偏移量,为了应付奇葩需求，只能动态计算缩放比例，然后重新设置相应的overlay位置了
                // 如果执行了屏幕缩放，就要计算相应的缩放量，然后将offset相应的前去缩放量的一半，这样基本上可以进行相应位置的定位不变
                // 左上角还是左上角，右下角还是右下角
                let domWidth=parseInt(overlayDom.style.width)||0;
                let domHeight=parseInt(overlayDom.style.height)||0;
                let offsetWidth=domWidth*(1-ratio)/2;
                let offsetHeight=domHeight*(1-ratio)/2;
                let offset=[0,-10];
                let anchor=featureProperties.anchor;
                switch (anchor) {
                    case "bottom-left":
                        offset=[10-offsetWidth,-10+offsetHeight];
                        break;
                    case "bottom-center":
                        offset=[0,-40+offsetHeight];
                        break;
                    case "bottom-right":
                        offset=[-15+offsetWidth,-20+offsetHeight];
                        break;
                    case "center-left":
                        offset=[10-offsetWidth,0];
                        break;
                    case "center-center":
                        offset=[0,0];
                        break;
                    case "center-right":
                        offset=[-10+offsetWidth,0];
                        break;
                    case "top-left":
                        offset=[15-offsetWidth,20-offsetHeight];
                        break;
                    case "top-center":
                        offset=[0,40-offsetHeight];
                        break;
                    case "top-right":
                        offset=[-15+offsetWidth,20-offsetHeight];
                        break;
                }
                overlay.setOffset(offset);


                //控制属性的显示和隐藏,站点配置项中是否显示属性、以及显示哪些类型的站点和地图级别是否达到了显示要求
                if(zoom>=propertiesZoom){
                    let coordinate=feature.getGeometry().getCoordinates();

                    //计算lebal位置
                    let anchor=featureProperties.anchor;
                    overlay.setPositioning(anchor);
                    overlayDom.style.display="block";
                    overlay.setPosition(coordinate);
                }else {
                    overlay.setPosition(undefined);
                }

                // 清除Dom引用，防止内存泄漏
                overlayDom=null;
            }
            // //绑定事件
            // let $ztOverlay=$(".ztOverlay");
            // if(!$ztOverlay.data("events")||!$ztOverlay.data("events")["click"]){
            //     $ztOverlay.on("click",function () {
            //         let $this=$(this);
            //         $this.parent().addClass("ztOverlayStick").siblings().removeClass("ztOverlayStick");
            //     });
            // }
        },
           // 计算dom的缩放比
        detectZoom(){
            var ratio = 0,
            screen = window.screen,
            ua = navigator.userAgent.toLowerCase();
            if (window.devicePixelRatio !== undefined) {
                ratio = window.devicePixelRatio;
            }
            else if (~ua.indexOf('msie')) {
                if (screen.deviceXDPI && screen.logicalXDPI) {
                    ratio = screen.deviceXDPI / screen.logicalXDPI;
                }
            }
            else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                ratio = window.outerWidth / window.innerWidth;
            }

            if (ratio) {
                ratio = Math.round(ratio * 100);
            }
            ratio=ratio/100;
            if(ratio>1){
                ratio=1;
            }
            return ratio;
        },

        // 计算模拟值
        calculateSimulation(){
            // 获取各个输入框的值
            let overlays=this.mainmap.getOverlays();
            let CalcPipeInput=[];
            overlays.forEach(function(item){
                let group=item.get("group");
                if(group=="simulation"){
                    let el=item.getElement();
                    let SiteNo=el.dataset.number; // 站点编号
                    let inputArray=el.querySelectorAll(".ztOverlay_content input");

                    let simulationItem={}; // 用于组装请求参数
                    simulationItem.SiteNo=parseInt(SiteNo);

                    // 获取各个输入框的值
                    for(let inputItem of inputArray){
                        let filed=inputItem.dataset.name;
                        let value=parseFloat(inputItem.value)?parseFloat(inputItem.value):0;
                        simulationItem[filed]=value;
                    }

                    CalcPipeInput.push(simulationItem);

                    // 清除DOM引用
                    inputArray=null;
                }
            });
            // 各个计算框的值
            let calcStr=JSON.stringify({
                "CalcPipeInput":CalcPipeInput
            });

            // 去掉不需要的字段
            let currentColorSetting=this.colorSetting;
            // 去掉不需要的字段
            let color={
                id:currentColorSetting.id,
                itemName:currentColorSetting.itemName,
                name:currentColorSetting.name,
                isChecked:currentColorSetting.isChecked,
                colorPiece:currentColorSetting.colorPiece,
                colorBlock:[{
                    colorSection: currentColorSetting.colorBlock[0].colorSection,
                    upperValue: currentColorSetting.colorBlock[0].upperValue,
                    colorType:currentColorSetting.colorBlock[0].colorType,
                    lowerValue: currentColorSetting.colorBlock[0].lowerValue
                },{
                    colorSection: currentColorSetting.colorBlock[1].colorSection,
                    upperValue: currentColorSetting.colorBlock[1].upperValue,
                    colorType:currentColorSetting.colorBlock[1].colorType,
                    lowerValue: currentColorSetting.colorBlock[1].lowerValue
                }]
            }

            // 请求模拟值
            getSimulationValue(JSON.stringify(color),calcStr).then(data=>{
                //如果没有数据
                if(!data||(data.status&&data.status!=200)){
                    return;
                }

                //管线提示信息
                // var PipeTips=data.PipeTips;
                // var $pipeTips=$(".pipetips");
                // if(PipeTips){
                //     $pipeTips.show();
                //     $pipeTips.find(".title").html(PipeTips.Title);
                //     $pipeTips.find(".content").html(PipeTips.Text.replace(/\\n/g,"<br>"));
                // }else{
                //     $pipeTips.hide();
                // }

                //管线信息
                let PipePointItem=data.PipePointItem; 

                if(PipePointItem&&PipePointItem.UpdateTime){
                    var updateTime=PipePointItem.UpdateTime; //管线更新时间
                    //添加实时时间标签
                    // $(".simulation-wrap .realtime-wrap").html(updateTime).show();
                }
                // 管线的计算数据
                data=data.PipePointData;
                // 获取图层的所有的features
                if(!this.pipelineFeatureArray){
                    let layer=this.mainmap.getLayerByName("pipeline_layer");
                    let source=layer.getSource();
                    this.pipelineFeatureArray=source.getFeatures();
                }
                //遍历所有的线段,获取线段编号，然后根据线段编号从线段配置文件中读取相应的数据，根据起始和终点相减获取到数据长度，然后在实时数据中取相应的长度数据对应
                var featureArray=this.pipelineFeatureArray;

                for(var i=featureArray.length-1;i>=0;i--){
                    var feature=featureArray[i];

                    var featureProperties=feature.getProperties();
                    // 获取线段编号
                    var linenumber=featureProperties.number||featureProperties.Number;
                    var lineConfig=this.pipelineConfig[linenumber];
                    //如果线段中有配置项，则根据配置项进行绘制
                    if(lineConfig){
                        // 子编号在线段的配置文件里面，则获取数据
                        var subNumber=featureProperties.subnumber||featureProperties.SubNumber;
                        var sublineArray=lineConfig.sublineArray;
                        for(var j=sublineArray.length-1;j>=0;j--){
                            var subLineConfig=sublineArray[j];
                            var startNumber=subLineConfig.startIndex;
                            var endNumber=subLineConfig.endIndex;
                            if(subNumber>=startNumber&&subNumber<=endNumber){
                                // 获取每一段地图上的管线对应的管线实时数据的偏移量
                                // 偏移量=当前线段的子编号-线段配置文件中的开始编号+线段配置文件中的数据开始偏移量
                                var offsetIndex=subNumber-startNumber+subLineConfig.dindex;
                                var realData=data[offsetIndex];
                                realData.updateTime=updateTime;

                                //获取到真是数据后，根据数据绘制内容
                                feature.set("realdata",realData);
                                feature.setStyle(this.pipelineStyleFun(feature));
                            }
                        }
                    }
                }
            })
        },
        //绘制管线样式
        pipelineStyleFun:function (feature) {
             var featureProperties=feature.getProperties();
            //根据当前配置项，显示数据
            var currentColorSetting=this.colorSetting;
            var realDataType=currentColorSetting.itemName;
            if(!featureProperties.realdata||!featureProperties.realdata[realDataType]){
                return ;
            }
            // 当前实时数据的颜色值
            var currentValue=featureProperties.realdata[realDataType];

            var style=new Style({
                stroke: new Stroke({
                    color: currentValue,
                    width:4,
                    lineCap:"square"
                })
            });
            return style;
        },
    }
}
</script>
<style lang="scss">
.simulation-wrap{
    position: absolute;
    right:10px;
    top:35rem;
    z-index: 10;

    .simulation-btn{
        border-radius: 5px;
        color:#5B5B5B;
        font-size: 14px;
        overflow: hidden;
        // zoom:1;
        text-align: center;
    }
    .simulation-btn .item{
        float: left;
        padding:5px 10px;
        cursor: pointer;
        background: #FFFFFF;
        border:1px solid #D3D3D3;
        margin:0;
    }
    .item.selected{
        color:#3086FF;
        border:1px solid #3086FF;
    }
    .simulation-btn .item:first-child{
        border-right: 1px solid #D3D3D3;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .simulation-btn .item:last-child{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .simulation-content .item{
        padding:5px 10px;
        cursor: pointer;
        border-radius: 5px;
        background: #FFFFFF;
        color:#5B5B5B;
        font-size: 14px;
        text-align: center;
        margin-top:10px;
    }
    .realtime-wrap{
        position: absolute;
        top: -55px;
        width:100%;
        height: 46px;
        width: 100%;
        background: #fff;
        border-radius: 4px;
        padding: 4px;
        text-align: center;
        font-size: 14px;
        display: none;
    }
    .realtime-wrap:after{
        position: absolute;
        content: " ";
        margin-left: -10px;
        float: left;
        top: 100%;
        width: 0;
        height: 0;
        border-width: 10px;
        border-style: solid;
        border-color:#fff transparent transparent transparent;
    }
}
/**模拟面板 */
.ztOverlay .simulation-item {
    margin-bottom: 5px;
    width:222px;
}
.ztOverlay .simulation-item input {
    height: initial;
    line-height: initial;
    padding: 3px;
    width: 65%;
    margin-bottom: 0;
}
</style>